<template>
  <div id="bottomRight">
    <div class="bg-color-black">
      <div class="d-flex title-box">
        <div class="d-flex">
          <span class="fs-xl text_title mx-2 commonTitle">库存预警提醒</span>
          <div class="decoration2">
            <dv-decoration-2 :reverse="true" style="width: 5px; height: 6rem" />
          </div>
        </div>
      </div>
      <div class="body-box">
        <div class="custom_table padding-xs">
          <ul class="header_ul d-flex fs14 text-info-1">
            <li>仓库</li>
            <li>品名</li>
            <li>警戒数</li>
            <li>库存数</li>
          </ul>

          <vue-seamless-scroll
            :data="listData"
            :class-option="classOption"
            class="warp"
            ref="scroll3"
          >
            <ul class="tbody_ul" v-if="warnList.length > 0">
              <li v-for="(item, index) in warnList" :key="index" class="d-flex fs14 text-info-1">
                <span>{{ item.areaName }}</span>
                <span>{{ item.spuName }}</span>
                <span>{{ item.numWaring }}</span>
                <span style="color: #e77d35">{{ item.num }}</span>
              </li>
            </ul>
            <div v-else class="d-flex jc-center text-info-1 padding-top-sm fs14">暂无数据...</div>
          </vue-seamless-scroll>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from "@/api/index";

export default {
  data() {
    return {
      loading: false,
      warnList: [],
      params: {
        customerId: "",
      },
      intervalId: null,
      classOption: {
        singleHeight: 40,
        waitTime: 5000,
      },
      listData: [],
    };
  },
  mounted() {
    this.params.customerId = this.$route.query.customerId;
    if (this.$refs.scroll3 && this.$refs.scroll3._cancle) {
      this.$refs.scroll3._cancle();
    }
    this.getData();

    this.intervalId = setInterval(() => {
      this.getData();
    }, 30 * 60 * 1000);
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  methods: {
    async getData() {
      const res = await api.getSpuStockWarning(this.params);
      if (res.ResultCode === 0) {
        this.warnList = res.Result || [];
        this.listData = this.warnList;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#bottomRight {
  width: 100%;
  height: 100%;
  border-radius: 5px;

  .bg-color-black {
    height: 100%;
    border-radius: 10px;
    overflow: hidden;
    .title-box {
      height: 18%;
      padding: 0 15px;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
    }
    .body-box {
      height: 77%;
      overflow: hidden;
    }
  }

  .decoration2 {
    position: absolute;
    right: 0.125rem;
  }

  .custom_table {
    .header_ul {
      flex-flow: row nowrap;
      justify-content: space-between;
      height: 10%;
      li {
        flex: 1;
        text-align: center;
      }
    }

    .tbody_ul {
      height: calc(90%);
      overflow-y: auto;
      padding-top: 5px;

      li {
        height: calc(100%);
        margin-bottom: 13px;
        span {
          flex: 1;
          text-align: center;
        }
      }
    }
  }
  .fs14 {
    font-size: 14px;
  }
}

.warp {
  height: 100%;
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
}
</style>

